/**
 * MetricCard — a small dashboard/nav card: icon + uppercase title, an optional
 * big value (stat card) and/or subtitle, optionally a Link (nav card).
 *
 * Extracted 2026-06-21 (Admin/Compliance nav reorg) so the Admin landing and the
 * Compliance overview render identical cards (§3h consistency). Previously local
 * to CompliancePage.
 */
import { Anchor, Card, Group, Stack, Text } from '@mantine/core';
import type * as React from 'react';
import { Link } from 'react-router-dom';

export interface MetricCardProps {
  title: string;
  value?: number | string;
  subtitle?: string;
  color?: string;
  icon: React.ComponentType<{ size?: number | string; color?: string }>;
  to?: string;
}

export function MetricCard({ title, value, subtitle, color = 'azul', icon: Icon, to }: MetricCardProps) {
  const inner = (
    <Card withBorder p="lg" radius="md" h="100%">
      <Group gap="md" align="flex-start" wrap="nowrap">
        <Icon size={32} color={`var(--mantine-color-${color}-6)`} />
        <Stack gap={4} style={{ flex: 1 }}>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>{title}</Text>
          {value !== undefined && <Text size="xl" fw={700} c={`${color}.7`}>{value}</Text>}
          {subtitle && <Text size="xs" c="dimmed">{subtitle}</Text>}
        </Stack>
      </Group>
    </Card>
  );
  if (to) {
    return (
      <Anchor component={Link} to={to} underline="never" style={{ display: 'block', height: '100%' }}>
        {inner}
      </Anchor>
    );
  }
  return inner;
}
